import { graphql } from 'src/graphql';

export const TeamInsights = graphql(`
  query TeamInsights($first: Int, $after: String, $filter: InsightsFilter) {
    insights(first: $first, after: $after, filter: $filter) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        _id
        code
        title
        created_at
        short_name
        created_by {
          _id
          displayName
        }
      }
    }
  }
`);
